var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orgBox" },
    [
      _c("el-input", {
        ref: "searchKey",
        staticClass: "searchKey",
        attrs: { placeholder: "搜索", "prefix-icon": "el-icon-search" },
        model: {
          value: _vm.searchKeyWord,
          callback: function ($$v) {
            _vm.searchKeyWord = $$v
          },
          expression: "searchKeyWord",
        },
      }),
      _c(
        "orgBox2",
        _vm._b(
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showSearchList,
                expression: "!showSearchList",
              },
            ],
            ref: "orgBox",
          },
          "orgBox2",
          _vm.orgBox2Props,
          false
        )
      ),
      _vm.showSearchList
        ? _c(
            "orgBox2",
            _vm._b(
              { attrs: { "is-search": true } },
              "orgBox2",
              _vm.orgBox2Props,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }